import HttpService from "./HttpService";
const API_URL = "/recruitment";

const RecruitmentRequisitionService = {
  fetch: async () => {
    try {
      const response = await HttpService.get(`${API_URL}-requisition`);
      return response.data;
    } catch (error) {
      console.error("Error fetching recruitment requisitions:", error);
      throw error;
    }
  },
  fetchAdminRequisitions: async () => {
    try {
      const response = await HttpService.get(`${API_URL}-requisition-admin`);
      return response.data;
    } catch (error) {
      console.error("Error fetching recruitment requisitions:", error);
      throw error;
    }
  },
  // `pageConfig` accepts { page, per_page }. Response shape:
  // { data: { data: [...], pagination: { total_record, current_page, per_page, total_page } } }
  fetchManagerRequisitions: async (pageConfig = {}) => {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `${API_URL}-requisition-my-team-list?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching recruitment requisitions:", error);
      throw error;
    }
  },
  // Server-side export for the My Team requisition tabs. `type` is
  // "excel" | "pdf". Returns the raw axios response (response.data is a Blob).
  exportManagerRequisitions: async (type) => {
    return HttpService.post(
      `${API_URL}-requisition-my-team-list-export`,
      { type },
      { responseType: "blob", timeout: 0 }
    );
  },
  exportManagerRequisitionDrafts: async (type) => {
    return HttpService.post(
      `${API_URL}-requisition-my-team-list-drafts-export`,
      { type },
      { responseType: "blob", timeout: 0 }
    );
  },
  fetchRequisitionWithFilters: async (parameters) => {
    try {
      const response = await HttpService.post(`${API_URL}-requisition-list`, parameters);
      return response.data;
    } catch (error) {
      console.error("Error fetching recruitment requisitions:", error);
      throw error;
    }
  },
  fetchAssignedRequisition: async () => {
    try {
      const response = await HttpService.get(`recruitment-requisition-recruiter-get`);
      return response.data;
    } catch (error) {
      console.error("Error fetching recruitment requisitions:", error);
      throw error;
    }
  },
  fetchPublishedRequisition: async () => {
    try {
      const response = await HttpService.get(`recruitment-requisition-publish`);
      return response.data;
    } catch (error) {
      console.error("Error fetching recruitment requisitions:", error);
      throw error;
    }
  },
  // `pageConfig` accepts { page, per_page }. Response shape:
  // { data: { data: [...], pagination: { total_record, current_page, per_page, total_page } } }
  fetchInternalJobOpenings: async (pageConfig = {}) => {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `/recruitment-requisition-list-internal?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching internal job openings:", error);
      throw error;
    }
  },
  // Server-side export. `type` is "excel" | "pdf". Returns the raw axios
  // response (response.data is a Blob).
  exportInternalJobOpenings: async (type) => {
    return HttpService.post(
      `/recruitment-requisition-list-internal-export`,
      { type },
      { responseType: "blob", timeout: 0 }
    );
  },
  fetchExternalJobOpenings: async () => {
    try {
      const response = await HttpService.get(`/recruitment-requisition-list-external`);
      return response.data;
    } catch (error) {
      console.error("Error fetching internal job openings:", error);
      throw error;
    }
  },

  add: async (data) => {
    try {
      const response = await HttpService.post(`${API_URL}-requisition`, data);
      return response.data;
    } catch (error) {
      console.error("Error adding recruitment requisition:", error);
      throw error;
    }
  },

  edit: async (id) => {
    try {
      const response = await HttpService.get(
        `${API_URL}-requisition/${id}/edit`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  view: async (id) => {
    try {
      const response = await HttpService.get(`${API_URL}-requisition/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, updatedData) => {
    // data["_method"] = "PUT";
    try {
      const response = await HttpService.put(
        `${API_URL}-requisition/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating recruitment requisition:", error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await HttpService.delete(`${API_URL}-requisition/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting recruitment requisition:", error);
      throw error;
    }
  },

  fetchStatus: async (id) => {
    try {
      const response = await HttpService.get(`${API_URL}-status-get/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching recruitment requisition status:", error);
      throw error;
    }
  },

  storeStatus: async (data) => {
    try {
      const response = await HttpService.post(`${API_URL}-status`, data);
      return response.data;
    } catch (error) {
      console.error("Error storing recruitment status:", error);
      throw error;
    }
  },
  updateRequisitionStatus: async (data) => {
    try {
      const response = await HttpService.post(`/requisition-status`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating requisiton status:", error);
      throw error;
    }
  },
  republishRequisition: async (id, data) => {
    try {
      const response = await HttpService.post(`recruitment-requisition-republished/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating requisiton status:", error);
      throw error;
    }
  },

  assignRequisition: async (id, data) => {
    try {
      const response = await HttpService.post(`/assign-recruiter/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error assigning recruitment: ", error);
      throw error;
    }
  },

  publishRequisition: async (id) => {
    try {
      const response = await HttpService.get(`/requisition-publish/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error publishing recruitment requisition:", error);
      throw error;
    }
  },

  fetchPublishedRequisitions: async () => {
    try {
      const response = await HttpService.get(`${API_URL}-requisition-get`);
      return response.data;
    } catch (error) {
      console.error("Error fetching published recruitment requisitions:", error);
      throw error;
    }
  },
  fetchPrefixWisePublishedRequisitions: async (data) => {
    try {
      const response = await HttpService.post(`${API_URL}-requisition-publish`, data);
      return response.data;
    } catch (error) {
      console.error("Error fetching published recruitment requisitions:", error);
      throw error;
    }
  },
  fetchOpenRequisitions: async (parameters) => {
    try {
      const response = await HttpService.post(`${API_URL}-open-requsition`, parameters);
      return response.data;
    } catch (error) {
      console.error("Error fetching published recruitment requisitions:", error);
      throw error;
    }
  },
  fetchClosedRequisitions: async (parameters) => {
    try {
      const response = await HttpService.post(`${API_URL}-closed-requsition`, parameters);
      return response.data;
    } catch (error) {
      console.error("Error fetching published recruitment requisitions:", error);
      throw error;
    }
  },
  fetchJob: async (id) => {
    try {
      const response = await HttpService.get(
        `${API_URL}-requisition-edit/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default RecruitmentRequisitionService;
